import { cn } from '@/lib/utils';

import { CodeBlockItem } from '@/decodo/components/atoms/CodeBlock/CodeBlockItem';
import { ResponseFormatView } from '@/features/scraper/constants/response-formats';
import { getTabularData } from './helpers';
import { useTranslation } from '@/lib/i18n/i18n.client';
import { EmptyRichResponse } from './components/EmptyRichResponse';
import { useScraper } from './state/context';

export const JSONResponseView = ({
  viewType,
  data,
}: {
  viewType: ResponseFormatView;
  data: any;
}) => {
  const { target } = useScraper();
  const { texts } = useTranslation();
  const content = data;

  const renamedTitle: Record<string, string> = {
    pos: texts.scraper.json_view_title.position,
    url: texts.scraper.json_view_title.URL,
    title: texts.scraper.json_view_title.title,
    desc: texts.scraper.json_view_title.description,
  };

  if (viewType === 'rich') {
    try {
      const table = getTabularData({
        target,
        json: content,
      });

      if (table.columns.length === 0) {
        return <EmptyRichResponse message='Table not available' />;
      }

      return (
        <table className='text-body-s w-full border-spacing-4 text-left'>
          <thead className='border-b border-gray-400'>
            <tr className=''>
              {table.columns.map((column) => (
                <th
                  className='text-label-text-m px-1 pb-4 uppercase text-gray-600'
                  key={column}
                >
                  {renamedTitle[column] ?? column}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {table.data.map((row, i) => {
              return (
                <tr
                  key={i}
                  className={cn(
                    'h-16 align-top',
                    i < table.data.length - 1 && 'border-b border-gray-400'
                  )}
                >
                  {table.columns.map((column, i) => {
                    const betterRow = table.rowAccessor
                      ? (table.rowAccessor(row) as Record<string, string>)
                      : (row as Record<string, string>);
                    return (
                      <td key={i} className='px-1 py-2 '>
                        <div className='max-h-20 max-w-[200px] overflow-y-auto'>
                          {betterRow[column]}
                        </div>
                      </td>
                    );
                  })}
                </tr>
              );
            })}
          </tbody>
        </table>
      );
    } catch (error) {
      return <EmptyRichResponse message='Table not available' />;
    }
  }
  return (
    <CodeBlockItem code={JSON.stringify(content, null, '\t')} language='JSON' />
  );
};
